export abstract class ExceptionBase extends Error {

    protected constructor(message?: string) {
        super(message);
    }

}
